import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IUserResponsibilityProfile } from '@nimbus-library/features/agent-assistant/models/agent-assistant.model';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';
import { ChatChannelType, InitialModality } from '@nimbus-library/features/shared/models/participant-info/i-combined-conversation.response';

@Injectable({ providedIn: 'root' })
export class AgentAssistantApiClient {
  public constructor(private readonly baseHttpService: BaseHttpService) {}

  public getUserResponsibilityProfiles(userId: string): Observable<IUserResponsibilityProfile[]> {
    return this.baseHttpService.get(`user-manager/v1/users/${userId}/responsibility-profiles`);
  }

  public setUserResponsibilityProfile(userId: string, responsibilityProfileId: string): Observable<boolean> {
    return this.baseHttpService.put(`user-manager/v1/users/${userId}/responsibility-profiles/${responsibilityProfileId}/activate`);
  }

  public extendAcw(
    callId: string,
    callSessionId: string,
    userSessionId: string,
    initialModality: InitialModality,
    channel?: ChatChannelType,
    tenantId?: string,
    userId?: string,
  ): Observable<void> {
    switch (initialModality) {
      case InitialModality.InstantMessaging:
        switch (channel) {
          case ChatChannelType.TwilioWhatsapp:
          case ChatChannelType.TwilioSms:
          case ChatChannelType.TwilioRcs:
            return this.baseHttpService.post(
              `acs/chat-handler/tenants/${tenantId}/conversations/${callSessionId}/after-call-work/extend?userId=${userId}`,
            );
          default:
            return this.callDefaultAcwAction('extend', callId, callSessionId, userSessionId);
        }
      case InitialModality.Email:
        return this.baseHttpService.post(
          `email-handler/v1/unified-sessions/${callId}/sessions/${callSessionId}/userSessions/${userSessionId}/after-call-work/extend`,
        );
      default:
        return this.callDefaultAcwAction('extend', callId, callSessionId, userSessionId);
    }
  }

  public stopAcw(
    callId: string,
    callSessionId: string,
    userSessionId: string,
    initialModality: InitialModality,
    channel?: ChatChannelType,
    tenantId?: string,
    userId?: string,
  ): Observable<void> {
    switch (initialModality) {
      case InitialModality.InstantMessaging:
        switch (channel) {
          case ChatChannelType.TwilioWhatsapp:
          case ChatChannelType.TwilioSms:
          case ChatChannelType.TwilioRcs:
            return this.baseHttpService.post(
              `acs/chat-handler/tenants/${tenantId}/conversations/${callSessionId}/after-call-work/stop?userId=${userId}`,
            );
          default:
            return this.callDefaultAcwAction('stop', callId, callSessionId, userSessionId);
        }
      case InitialModality.Email:
        return this.baseHttpService.post(
          `email-handler/v1/unified-sessions/${callId}/sessions/${callSessionId}/userSessions/${userSessionId}/after-call-work/stop`,
        );
      default:
        return this.callDefaultAcwAction('stop', callId, callSessionId, userSessionId);
    }
  }

  public stopRona(userId: string): Observable<void> {
    return this.baseHttpService.post(`taskmanager/v1/Users/${userId}/persistent-rona/stop`);
  }

  private callDefaultAcwAction(action: 'extend' | 'stop', callId: string, callSessionId: string, userSessionId: string): Observable<void> {
    return this.baseHttpService.post(
      `callhandler/v1/Calls/${callId}/sessions/${callSessionId}/userSessions/${userSessionId}/after-call-work/${action}`,
    );
  }
}
